<template>
  <div class="align-items-end sticky-footer container my-auto pt-4">
    <div class="copyright text-center text-black-50 my-auto">
      <small
        ><span class="d-none d-sm-inline">Developed by </span>Information
        technology and procession section,
        <span class="d-block d-md-inline"
          >Registration office, Chiang Mai University &copy; 2021</span
        ></small
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "PageFooter",
};
</script>
